import { render, staticRenderFns } from "./Pallets.vue?vue&type=template&id=dd3f0364&scoped=true"
import script from "./Pallets.vue?vue&type=script&lang=js"
export * from "./Pallets.vue?vue&type=script&lang=js"
import style0 from "./Pallets.vue?vue&type=style&index=0&id=dd3f0364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3f0364",
  null
  
)

export default component.exports